import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'order',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },
  {
    path: '',
    redirectTo: 'order',
    pathMatch: 'full',
  },
];
